import _ from "lodash";

export function isBlank(value) {
    return (
        (_.isEmpty(value) && !_.isNumber(value)) ||
        _.isNaN(value) ||
        _.isNil(value)
    );
}
